const _hostname = window.location.hostname;
// 外包使用测试
// let base = '//dccs.foundao.com:90/dc/api'
// let host = "http://cms-bjnews.iuxiao.com/h5"

// 2023-03-23新地址
let base = 'http://bjdcapi-test.bjnews.com.cn'

let host = "http://bjdcweb-test.bjnews.com.cn/dc_h5/main"
// 文明实践
// 外包使用测试
// let cBase = '//dccs.foundao.com:90/dc_culture/api/'
// 2023-03-23新地址
let cBase = '//dcwmsjapi-test.bjnews.com.cn'

// 东城接口配置
// if (_hostname === 'cms-bjnews.iuxiao.com' || _hostname === 'localhost' || _hostname === '192.168.1.8'|| _hostname === '192.168.31.145') {   //测试环境
//   base = '//dccs.foundao.com:90/dc/api'
//   host = "http://cms-bjnews.iuxiao.com/h5"
//   // http://dccs.foundao.com:83/h5/#/
// }else{   //正式环境
//   base = '//bjdcapi.bjnews.com.cn'
//   host = "//cdn.bjnews.com.cn/h5"
// }
if (_hostname === 'cms-bjnews.iuxiao.com' || _hostname === '192.168.1.8'|| _hostname === 'localhost' || _hostname === 'dccs.foundao.com' ||  _hostname === 'bjdcweb-test.bjnews.com.cn') {   //测试环境
    // base = '//dccs.foundao.com:90/dc/api'
    // 外包使用测试
    // base = '//dccs.foundao.com:90/dc/api'
    // 2023-03-23新地址
    base = 'http://bjdcapi-test.bjnews.com.cn'
    host = "http://bjdcweb-test.bjnews.com.cn/dc_h5/main"
    // http://dccs.foundao.com:83/h5/#/
  }else {   //正式环境
    base = '//bjdcapi.bjnews.com.cn'
    host = "//cdn.bjnews.com.cn/h5"
  }
// 文明实践接口配置
//  http://bjdcweb.bjnews.com.cn/
if (_hostname === 'cms-bjnews.iuxiao.com' || _hostname === 'localhost' || _hostname === '192.168.1.8'|| _hostname === '192.168.31.145' || _hostname === 'dcwmsjapi-test.bjnews.com.cn') {   //测试环境
  // 外包使用测试
  // cBase = '//dccs.foundao.com:90/dc_culture/api'
  // 2023-03-23新地址
  cBase = '//dcwmsjapi-test.bjnews.com.cn'
} else{   //正式环境
  cBase = '//dcwmsjapi.bjnews.com.cn'
}
var API = {
  base: base,
  host: host,
  map_icon: host + "/resource/map_icon.png", // 地图icon
  manuscript_detail: base + '/news/manuscript_detail.php', // 图文稿件详情
  special_detail: base + '/news/special_detail.php', // 专题详情
  graph_article_detail: base + '/news/graph_article_detail.php', // 图说文章详情
  video_detail: base + '/news/video_detail.php', // 视频文章详情
  boutique_video_list: base + '/news/boutique_video_list.php', //视频相关推荐列表
  pv: base + '/census/pv.php', // pv统计
  live_group : base + '/news/live_group_text.php', // 图文直播
  comment_list : base + '/news/comment_list.php', // 评论列表
  reply_list : base + '/news/reply_list.php', //获取评论回复列表 
  audio_detail: base + '/news/audio_detail.php', //音频稿件详情
  column_news: base + '/news/column_news.php', // 栏目列表
  preview_detail: base + '/news/preview_detail.php', // 预览详情

  //新增：东城号主页
  homepage: base + '/news/homepage.php', // 东城号主页

  // -------------------文明实践--------------------
  // 实践所
  practiceList:cBase + '/street/street_list.php', // 所有街道列表
  practiceBaseList:cBase + '/base/base_list.php', // 所有实践基地列表
  practiceStreetDetail:cBase + '/street/street_info.php', // 街道详情
  practiceStationDetail:cBase + '/street/practice_place_info.php', // 街道实践站详情
  practiceBaseDetail:cBase + '/base/base_info.php', // 基地详情
  baseActivityDetail:cBase + '/base/base_activity_info.php', // 基地活动详情
  stationActivityDetail:cBase + '/street/place_activity_info.php', // 所站活动详情
  stationTeamList:cBase + '/volunteer/volunteer_list.php', // 志愿队伍列表
  stationTeamDetail:cBase + '/volunteer/volunteer_info.php', // 志愿队伍详情
  // 文章详情
  civ_manuscript_detail: cBase + '/news/manuscript_detail.php', // 文明实践图文稿件详情
  civ_graph_article_detail: cBase + '/news/graph_article_detail.php', // 文明实践图说稿件详情
  civ_video_detail: cBase + '/news/video_detail.php', // 文明实践视频稿件详情

  // 机构职能
  organization_list: base + '/other/department.php', // 机构职能，委办局1，街道2
  organization_detail: base + '/other/government_proxy.php', // 机构职能详情
  // 分享配置参数
  share_title: '北京东城', // 分享标题
  share_des: '东城人的地界，东城人的事，都在北京东城APP！', // 分享简介
  // share_img: 'http://dccs.foundao.com:83/h5/icon.png', // 分享封面外包原地址dccs.foundao.com
  share_img: 'http://bjdcweb-test.bjnews.com.cn/dc_h5/main/icon.png', // 分享封面
  appid: 'wx53df963e29e4a7a9', //id 
}

export default API;

// 普通专题分享页:
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/subject/1/专题uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/subject/1/153914868011238
// 时间轴专题分享页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/subject/2/专题uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/subject/2/153907744811213
// 图文详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/1/详情uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/1/153914824111237
// 普通视频详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/详情uuid/2
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/153905474211138/2
// 直播详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/详情uuid/6
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/153939794111313/6
// 图说详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/3/详情uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/3/153941330111338


// WEBPACK FOOTER //
// ./src/config/api.js